import { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { setAlert } from '../../actions/alert';
import { crearAsesoria } from '../../actions/asesorias';

const NuevaAsesoria = () => {

    let rutasBread = [
        {
            activo: false,
            nombre: 'Asesorías',
            path: '/asesorias'
        },
        {
            activo: true,
            nombre: 'Nueva asesoría',
            path: '/asesorias/nuevo'
        }
    ];

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { empresa } = useSelector(state => state.auth);

    useEffect(() => {
        if(!(empresa?.nombre_comercial && empresa?.rfc)) {
            dispatch(setAlert('Completa tu perfil empresarial antes de crear una asesoría.', 'warning'));
            navigate('/configuracion/perfil_empresarial');
        }
    }, [empresa]);

    const [asesoriaData, setAsesoriaData] = useState({
        motivo: null, 
        fecha: null, 
        descripcion: null
    });

    /* Nueva asesoría */
    const handleInputChange = ({ target }) => {
        setAsesoriaData({
            ...asesoriaData,
            [target.name]: target.value
        });
    }

    const handleDatePicker = (name, value) => {
        setAsesoriaData({
            ...asesoriaData,
            [name]: value
        });
    }

    const handleGuardarAsesoria = async () => {
        if(asesoriaData.motivo && asesoriaData.fecha){
            await dispatch(crearAsesoria(asesoriaData));

            await navigate("/asesorias");
        }else{
            await dispatch(setAlert('El motivo y fecha son obligatorios', 'danger'));
        }
    }

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);    

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="title-section my-5">Nueva asesoría</h3>

                    <div className="row">
                        <div className="col-md-9 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Motivo" id="motivo" name="motivo" value={asesoriaData.motivo} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="motivo">Motivo</label>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <DatePicker
                                        id="fecha"
                                        name="fecha"
                                        className="form-control text-center input-datepícker"
                                        dateFormat="dd/MM/yyyy"
                                        locale="es-ES"
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        selected={ asesoriaData.fecha != null ? new Date(asesoriaData.fecha) : '' }
                                        onChange={ date => handleDatePicker('fecha', date) }
                                    />
                                    <label className="label-datepicker" htmlFor="fecha">Fecha de creación</label>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-md-12 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <textarea className="form-control textareaCampo" placeholder="Descripción" id="descripcion" name="descripcion" value={asesoriaData.descripcion} onChange={e => handleInputChange(e)}></textarea>
                                    <label htmlFor="descripcion">Descripción</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-12 my-5">
                            <button className="btn btn-success float-end" onClick={handleGuardarAsesoria}>Guardar</button>
                            <Link to='/asesorias'><button className="btn btn-danger float-end me-2">Cancelar</button></Link>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default NuevaAsesoria;